<p-dialog header="New Phone" [(visible)]="visible" [modal]="true" [style]="{width:'460px'}" (onHide)="close()" [closable]="true">
  <div class="formgrid grid">
    <div class="col-12 field">
      <p-floatLabel>
        <input id="phone" type="tel" pInputText [(ngModel)]="workingPhone.phoneNumber" class="w-full" />
        <label for="phone">Phone Number</label>
      </p-floatLabel>
    </div>
  </div>
  <p-footer>
    <p-button label="Cancel" icon="pi pi-times" class="p-button-text" (onClick)="onCancel()"></p-button>
    <p-button label="Save" icon="pi pi-check" (onClick)="onSave()"></p-button>
  </p-footer>
</p-dialog>
